import { FACEBOOK_PRIVACY_OPTIONS } from '../../constants/platformCompliance';

const FacebookSettingsPanel = ({ settings, onChange, capabilities }) => {
  const pages = capabilities?.availablePages || [];
  const hasMultiplePages = pages.length > 1;
  const selectedPage = pages.find(p => p.pageId === settings.pageId) || pages[0];

  // Auto-select first page if none selected
  if (!settings.pageId && pages.length > 0 && pages[0].pageId) {
    onChange({ ...settings, pageId: pages[0].pageId });
  }

  return (
    <div className="space-y-4">
      {/* Page Selector */}
      {hasMultiplePages ? (
        <div>
          <label className="label">Post to Page</label>
          <select
            className="input w-full"
            value={settings.pageId || ''}
            onChange={e => onChange({ ...settings, pageId: e.target.value })}
          >
            {pages.map(p => (
              <option key={p.pageId} value={p.pageId}>{p.name}</option>
            ))}
          </select>
        </div>
      ) : null}

      {/* Posting-as Indicator */}
      {selectedPage && (
        <div className="flex items-center gap-3 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          {selectedPage.pictureUrl && (
            <img src={selectedPage.pictureUrl} alt="" className="w-10 h-10 rounded-full" />
          )}
          <div>
            <p className="text-xs text-gray-500 dark:text-gray-400">Posting as</p>
            <p className="font-medium text-gray-900 dark:text-white">{selectedPage.name}</p>
          </div>
        </div>
      )}

      {/* Page permission warning */}
      {selectedPage && selectedPage.hasPublishPermission === false && (
        <div className="p-3 bg-red-50 dark:bg-red-900/20 rounded-lg text-xs text-red-700 dark:text-red-300 font-medium">
          This page does not have CREATE_CONTENT permission. Publishing may fail. Check your page role permissions.
        </div>
      )}

      {pages.length === 0 && (
        <div className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg text-xs text-amber-800 dark:text-amber-200">
          No Facebook Pages found. You need at least one Facebook Page to publish content.
        </div>
      )}

      {/* Post Visibility */}
      <div>
        <label className="label">Post Visibility</label>
        <select
          className="input w-full"
          value={settings.facebookPrivacy || 'EVERYONE'}
          onChange={e => onChange({ ...settings, facebookPrivacy: e.target.value })}
        >
          {FACEBOOK_PRIVACY_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      {/* Link URL (optional) */}
      <div>
        <label className="label">Link URL (optional)</label>
        <input
          type="url"
          className="input w-full"
          value={settings.facebookLinkUrl || ''}
          onChange={e => onChange({ ...settings, facebookLinkUrl: e.target.value })}
          placeholder="https://example.com"
        />
        {settings.facebookLinkUrl && !isValidUrl(settings.facebookLinkUrl) && (
          <p className="text-xs text-red-500 mt-1">Please enter a valid URL</p>
        )}
      </div>

      {/* Scheduling moved to the unified "When to publish" control on the final publish step, so one
          picker schedules every platform the same way. The Facebook-native schedule toggle was removed
          to avoid two conflicting mechanisms. */}
    </div>
  );
};

function isValidUrl(str) {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
}

export default FacebookSettingsPanel;
